import { PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import { get_quote } from "../../../../Controllers/Sales/Quotes";
import moment from "moment";
import Loadercomponent from "../../../../Componets/Loader";
import toast from "react-hot-toast";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";
import headers from "../../../../Data/Forms/Sales/Quotes/headers";
import Header from "../../../../Componets/Header";
import formatCountryName from "../../../../Main/formatCountryName ";

const QuotesView = () => {
  let componentRef = useRef();
  const [header, setHeader] = useState(headers);

  let { id } = useParams();
  const [loader, setLoader] = useState(false);

  const [companyName, setCompanyName] = useState("For Company");

  const injectGlobalStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A4;
        margin: 6% 6% 16% 6%;
         @bottom-left {
        font-size: 12px;
       content: "\\A \\A \\A \\A Customer's Signature (Name/Designation/Co. Seal) \\A \\A \\A";
        white-space: pre;
        position: fixed;
        bottom: 10mm;
        left: 6%;
      }
      @bottom-right {
        font-size: 12px;
          content: "\\A \\A \\A \\A For ${companyName} \\A \\A " counter(page) " of " counter(pages);
        white-space: pre;
        position: fixed;
        bottom: 10mm;
        right: 6%;
      }
      }
    `;
    document.head.appendChild(style);
  };

  const [details, setDetails] = useState();

  const fetchData = async () => {
    setLoader(true);

    let data = {
      id: id,
    };

    let purchase = await get_quote(data);
    if (purchase?.status) {
      console.log(purchase?.data, "purchase?.data");
      setDetails(purchase?.data);
      setCompanyName(purchase?.data?.branch?.name);
      setLoader(false);
    } else {
      toast?.error(purchase?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (companyName) {
      injectGlobalStyles(companyName);
    }
  }, [companyName]);

  return (
    <Header headers={header} setHeaders={setHeader} >
      <Loadercomponent loader={loader}>
        <ScrollWrapper>
          <div className="flex justify-center">
            <div className="w-[8.27in]  text-right py-4">
              <ReactToPrint
                trigger={() => (
                  <div className="">
                    <PrinterOutlined className="text-2xl" />
                  </div>
                )}
                content={() => componentRef}
              />
            </div>
          </div>
          <div className="flex justify-center">
            <div className="page-a4" ref={(el) => (componentRef = el)}>
              {/*letter header */}
              <div className="text-black-900 text-[0.65rem] text-center">
                <div className="text-center">
                  <div className="text-medium text-xl">
                    {details?.branch?.name}
                  </div>
                  <div className="text-medium">{details?.branch?.category}</div>
                </div>
              </div>
              <div className="text-black-900 text-[0.65rem] text-center pt-4">
                <span>
                  Email&nbsp;:&nbsp;
                  {details?.branch?.email ? details?.branch?.email + ", " : ""}
                  &nbsp;
                </span>
                <span>
                  Phone&nbsp;:&nbsp;
                  {details?.branch?.phone ? details?.branch?.phone : "N/A"}
                  &nbsp;
                </span>
                {/* <span>F.Code&nbsp;:&nbsp;8756432,&nbsp;</span> */}
                <div>
                  {details?.branch?.area ? details?.branch?.area + ", " : ""}
                  {details?.branch?.city ? details?.branch?.city + ", " : ""}
                  {details?.branch?.country ? formatCountryName(details?.branch?.country) : ""}
                </div>
              </div>
              {/* heading */}
              <hr className="my-4 border-t-black-900 border-black" />
              <div className="text-medium text-xl text-center">Quotation</div>
              <div className="text-xs pb-6">
                <div className="flex justify-between">
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td className="font-semibold text-sm">
                            {details?.customer?.name}
                          </td>
                        </tr>
                        <tr>
                          <td>{details?.customer?.area}</td>
                        </tr>
                        <tr>
                          <td>
                            {details?.customer?.city
                              ? details?.customer?.city + ", "
                              : " "}
                            {details?.customer?.state}
                          </td>
                        </tr>
                        <tr>
                          <td>{formatCountryName(details?.customer?.country)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td>Quote No</td>
                          <td className="px-2">:</td>
                          <td className="text-right">#QO-{details?.number}</td>
                        </tr>
                        <tr>
                          <td>Date</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            {moment?.(details?.date)?.format?.("DD-MM-YYYY")}
                          </td>
                        </tr>
                        <tr>
                          <td>Validity</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            {details?.due_date ? moment?.(details?.due_date)?.format?.("DD-MM-YYYY") : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td>Reference</td>
                          <td className="px-2">:</td>
                          <td className="text-right">N/A</td>
                        </tr>
                        <tr>
                          <td>Phone</td>
                          <td className="px-2">:</td>
                          <td className="text-right">N/A</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* table */}
              <div className="">
                <table className="w-full">
                  <thead className="bg-black">
                    <tr className="text-sm">
                      <th className="font-normal  text-white  text-left py-2 pl-3">
                        S.No
                      </th>
                      <th className="font-normal text-white text-left p-2">
                        Description
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        Units
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        Quantity
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        Price
                      </th>
                      <th className="font-normal text-white text-center">Tax</th>
                      <th className="font-normal text-white text-right pr-2">
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    {details?.details?.map((value, index) => {
                      return (
                        <tr className="uppercase border-b border-gray-300 ">
                          <td className="py-1 text-center">{index + 1}</td>
                          <td className="py-1 text-left">
                            <div className="">{value?.name}</div>
                          </td>
                          <td className="py-1 text-center">{value?.unit_name}</td>
                          <td className="py-1 text-center">{value?.quantity}</td>
                          <td className="py-1 text-center">
                            {value?.sale_price?.toFixed(3)}
                          </td>
                          <td className="py-1 text-center">
                            <div>
                              <div>{value?.tax?.rate ? value?.tax?.rate : 0}%</div>
                              <div>{value?.tax_amount?.toFixed(3)}</div>
                            </div>
                          </td>
                          <td className="text-right pr-2">
                            {value?.total?.toFixed(3)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {/* table foot */}
                  <tbody className="text-sm ">
                    <tr className="">
                      <th colSpan={5}></th>
                      <th className="font-normal pt-1 text-right p-2">Total</th>
                      <td className="font-normal text-right p-2">
                        {details?.subtotal?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={5}></th>
                      <th className="font-normal text-right p-2">Tax Amount</th>
                      <td className="font-normal text-right p-2">
                        {details?.taxamount?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={5}></th>
                      <th className="font-normal text-right p-2">Discount</th>
                      <td className="font-normal text-right p-2">
                        {details?.discount
                          ? "-" + details?.discount?.toFixed(3)
                          : "0.000"}
                      </td>
                    </tr>

                    <tr>
                      <th className="" colSpan={5}></th>
                      <th className="font-normal text-right text-white bg-black p-2">
                        Grand&nbsp;Total&nbsp;(OMR)
                      </th>
                      <td className="font-normal text-right text-white bg-black p-2">
                        {details?.total?.toFixed(3)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* <div className="">
            <div
              className="page-footer mb-[1.5cm]"
              style={{ padding: " 1.6cm" }}
            >
              <div className="flex justify-between px-[0.5cm]">
                <div className="text-[0.65rem]">
                  Customer's Signature (Name/Designation/Co. Seal)
                </div>
                <div className="text-[0.65rem]">For New Pharmacy LLC</div>
              </div>
            </div>
          </div> */}
            </div>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default QuotesView;
